import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import LoadingAir from "../LoadingAir/LoadingAir";
import BgForm from "../../images/bg-form.png";
import React from "react";
import { formatDateNoTime } from "../../helpers/formatDate";

export default function Waiting({ airport, time }) {
  return (
    <div className="waiting-page h-[calc(100vh-120px)] px-0 py-4 items-center flex flex-col bg-primary">
      <img className="absolute !top-[100px]" src={BgForm} alt="" />
      <div>
        <LoadingAir />
        <div className="flex w-full top-[135px] left-1/2 justify-center items-center gap-8 mt-2">
          <div className="flex flex-col gap-1">
            <div className="text-white font-semibold text-[18px]">
              {airport?.[0]}
            </div>
          </div>
          <div className="relative">
            <svg
              width="123"
              height="47"
              viewBox="0 0 123 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary"
            >
              <path
                d="M0 20L5 22.8868V17.1132L0 20ZM123 20L118 17.1132V22.8868L123 20ZM4.5 20.5H118.5V19.5H4.5V20.5Z"
                fill="white"
              />
              <g filter="url(#filter0_d_212_3608)">
                <circle cx="62.5" cy="19.5" r="19.5" fill="white" />
              </g>
              <path
                d="M71.7335 30.404L73.3261 28.1785L68.063 16.3724L72.4426 10.2524C73.1035 9.32878 72.8628 8.06044 71.9037 7.4128C70.9446 6.76516 69.6368 6.9879 68.9759 7.91147L64.5963 14.0316L51.3703 13.3529L49.7777 15.5784L61.013 19.0389L56.6333 25.159L53.1278 25.2675L51.9333 26.9366L56.7741 28.5549L60.0223 32.3987L61.2167 30.7296L60.1 27.4999L64.4797 21.3798L71.7335 30.404Z"
                fill="currentColor"
              />
              <defs>
                <filter
                  id="filter0_d_212_3608"
                  x="39"
                  y="0"
                  width="47"
                  height="47"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_212_3608"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_212_3608"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-white font-semibold text-[18px]">
              {airport?.[1]}
            </div>
          </div>
        </div>
      </div>

      <div className="text-[14px] font-medium text-center mb-[14px] text-white justify-center">
        {`${formatDateNoTime(time[0])} ${time[1] ? `- ${formatDateNoTime(time[1])}` : ""}`}
      </div>

      <div>
        <p className="text-[14px] font-semibold text-center my-[26px] text-white">
          Vui lòng đợi trong giây lát <br />
          hệ thống đang tìm kiếm chuyến bay ...
        </p>
        <div className="flex justify-center">
          <Spin
            size="large"
            className="text-center"
            indicator={<LoadingOutlined spin />}
          />
        </div>
      </div>
    </div>
  );
}
